
import { BeatLoader } from 'react-spinners'
type Props = {
    loading : boolean
}
const Loader = (props: Props) => {
  return (
    <>
      {props.loading &&
        <div className='flex items-center justify-center z-[99999]  h-screen fixed bottom-0 left-0 top-0 right-0 bg-[#32323252]'>
            <BeatLoader className="d-inline" color="#8766CD" loading={props.loading} speedMultiplier={1} size={20} />
        </div>
      }
    </>
  )
}
export default Loader